const pageNameKey = "otaPushFirmwareModal";

export const otaPushFirmwareModalEn = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Close push firmware modal",
    closePushBackupModalAriaLabel: "Close push backup modal",
    titleFirmware: "Push Firmware",
    titleBackup: "Push Backup",
    firmwareSectionTitle: "The firmware",
    backupSectionTitle: "The backup",
    uploadedAtLabel: "uploaded",
    machineSectionTitle: "will be pushed to the machine",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "The firmware package contains the following folders:",
    backupFoldersSectionTitle:
      "The backup package contains the following folders:",
    targetPathLabel: "Target path on the machine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Username:",
    usernamePlaceholder: "Enter username",
    passwordLabel: "Password:",
    passwordPlaceholder: "Enter password",
    showPasswordTooltip: "Show password",
    hidePasswordTooltip: "Hide password",
    privateKeyFileForAuthLabel: "Private key file for authentication:",
    privateKeyPasswordLabel: "Password for the Private Key file:",
    privateKeyPasswordPlaceholder: "Enter private key file password",
    helperTextFirmware:
      "Send the firmware package for verification and ask the Operator for approval.",
    helperTextBackup:
      "Send the backup package for verification and ask the Operator for approval.",
    cancelButtonText: "Cancel",
    askForApprovalButtonText: "Ask for Approval",
    pleaseFixFields: "Please fix the following fields:",
    failedToCreateInstallationProcess: "Failed to create installation process",
    installationProcessAlreadyExists:
      "An installation process is already active for this machine.",
    targetPathLabelWithoutColon: "Target path on the machine",
    usernameLabelWithoutColon: "Username",
    privateKeyFileForAuthLabelWithoutColon:
      "Private key file for authentication",
    passwordOrPrivateKeyRequired:
      "Either Password or Private key file for authentication",
  },
};

export const otaPushFirmwareModalPtBr = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Fechar modal de envio de firmware",
    closePushBackupModalAriaLabel: "Fechar modal de envio de backup",
    titleFirmware: "Enviar firmware",
    titleBackup: "Enviar backup",
    firmwareSectionTitle: "O firmware",
    backupSectionTitle: "O backup",
    uploadedAtLabel: "enviado em",
    machineSectionTitle: "será enviado para a máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "O pacote de firmware contém as seguintes pastas:",
    backupFoldersSectionTitle: "O pacote de backup contém as seguintes pastas:",
    targetPathLabel: "Caminho de destino na máquina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nome de usuário:",
    usernamePlaceholder: "Digite o nome de usuário",
    passwordLabel: "Senha:",
    passwordPlaceholder: "Digite a senha",
    showPasswordTooltip: "Mostrar senha",
    hidePasswordTooltip: "Ocultar senha",
    privateKeyFileForAuthLabel: "Arquivo de chave privada para autenticação:",
    privateKeyPasswordLabel: "Senha para o arquivo de chave privada:",
    privateKeyPasswordPlaceholder: "Digite a senha da chave privada",
    helperTextFirmware:
      "Envie o pacote de firmware para verificação e solicite aprovação do Operador.",
    helperTextBackup:
      "Envie o pacote de backup para verificação e solicite aprovação do Operador.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprobación",
    pleaseFixFields: "Por favor, corrija los siguientes campos:",
    failedToCreateInstallationProcess: "Falha ao criar processo de instalação",
    installationProcessAlreadyExists:
      "Um processo de instalação já está ativo para esta máquina.",
    targetPathLabelWithoutColon: "Caminho de destino na máquina",
    usernameLabelWithoutColon: "Nome de usuário",
    privateKeyFileForAuthLabelWithoutColon:
      "Arquivo de chave privada para autenticação",
    passwordOrPrivateKeyRequired:
      "Informe a senha ou o arquivo de chave privada",
  },
};

export const otaPushFirmwareModalDe = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Modal zum Firmware-Push schließen",
    closePushBackupModalAriaLabel: "Modal zum Backup-Push schließen",
    titleFirmware: "Firmware übertragen",
    titleBackup: "Backup übertragen",
    firmwareSectionTitle: "Die Firmware",
    backupSectionTitle: "Das Backup",
    uploadedAtLabel: "hochgeladen",
    machineSectionTitle: "wird auf die Maschine übertragen",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle: "Das Firmware-Paket enthält folgende Ordner:",
    backupFoldersSectionTitle: "Das Backup-Paket enthält folgende Ordner:",
    targetPathLabel: "Zielpfad auf der Maschine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Benutzername:",
    usernamePlaceholder: "Benutzernamen eingeben",
    passwordLabel: "Passwort:",
    passwordPlaceholder: "Passwort eingeben",
    showPasswordTooltip: "Passwort anzeigen",
    hidePasswordTooltip: "Passwort ausblenden",
    privateKeyFileForAuthLabel: "Private Schlüsseldatei zur Authentifizierung:",
    privateKeyPasswordLabel: "Passwort für die private Schlüsseldatei:",
    privateKeyPasswordPlaceholder:
      "Passwort für private Schlüsseldatei eingeben",
    helperTextFirmware:
      "Senden Sie das Firmware-Paket zur Verifizierung und bitten Sie den Operator um Freigabe.",
    helperTextBackup:
      "Senden Sie das Backup-Paket zur Verifizierung und bitten Sie den Operator um Freigabe.",
    cancelButtonText: "Abbrechen",
    askForApprovalButtonText: "Freigabe anfragen",
    pleaseFixFields: "Bitte beheben Sie die folgenden Felder:",
    failedToCreateInstallationProcess:
      "Installationsprozess konnte nicht erstellt werden",
    installationProcessAlreadyExists:
      "Für diese Maschine ist bereits ein Installationsprozess aktiv.",
    targetPathLabelWithoutColon: "Zielpfad auf der Maschine",
    usernameLabelWithoutColon: "Benutzername",
    privateKeyFileForAuthLabelWithoutColon:
      "Private Schlüsseldatei zur Authentifizierung",
    passwordOrPrivateKeyRequired:
      "Passwort oder private Schlüsseldatei ist erforderlich",
  },
};

export const otaPushFirmwareModalZhHans = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "关闭固件推送弹窗",
    closePushBackupModalAriaLabel: "关闭备份推送弹窗",
    titleFirmware: "推送固件",
    titleBackup: "推送备份",
    firmwareSectionTitle: "该固件",
    backupSectionTitle: "该备份",
    uploadedAtLabel: "上传于",
    machineSectionTitle: "将被推送到设备",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle: "固件包包含以下文件夹：",
    backupFoldersSectionTitle: "备份包包含以下文件夹：",
    targetPathLabel: "设备上的目标路径：",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "用户名：",
    usernamePlaceholder: "输入用户名",
    passwordLabel: "密码：",
    passwordPlaceholder: "输入密码",
    showPasswordTooltip: "显示密码",
    hidePasswordTooltip: "隐藏密码",
    privateKeyFileForAuthLabel: "用于身份验证的私钥文件：",
    privateKeyPasswordLabel: "私钥文件密码：",
    privateKeyPasswordPlaceholder: "输入私钥文件密码",
    helperTextFirmware: "发送固件包进行验证，并请求操作员批准。",
    helperTextBackup: "发送备份包进行验证，并请求操作员批准。",
    cancelButtonText: "取消",
    askForApprovalButtonText: "请求批准",
    pleaseFixFields: "请修复以下字段：",
    failedToCreateInstallationProcess: "创建安装流程失败",
    installationProcessAlreadyExists: "该设备已有一个正在进行的安装流程。",
    targetPathLabelWithoutColon: "设备上的目标路径",
    usernameLabelWithoutColon: "用户名",
    privateKeyFileForAuthLabelWithoutColon: "用于身份验证的私钥文件",
    passwordOrPrivateKeyRequired: "密码或私钥文件至少填写一项",
  },
};

export const otaPushFirmwareModalIt = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Chiudi la finestra di invio firmware",
    closePushBackupModalAriaLabel: "Chiudi la finestra di invio backup",
    titleFirmware: "Invia firmware",
    titleBackup: "Invia backup",
    firmwareSectionTitle: "Il firmware",
    backupSectionTitle: "Il backup",
    uploadedAtLabel: "caricato il",
    machineSectionTitle: "verra inviato alla macchina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "Il pacchetto firmware contiene le seguenti cartelle:",
    backupFoldersSectionTitle:
      "Il pacchetto backup contiene le seguenti cartelle:",
    targetPathLabel: "Percorso di destinazione sulla macchina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nome utente:",
    usernamePlaceholder: "Inserisci nome utente",
    passwordLabel: "Password:",
    passwordPlaceholder: "Inserisci password",
    showPasswordTooltip: "Mostra password",
    hidePasswordTooltip: "Nascondi password",
    privateKeyFileForAuthLabel: "File chiave privata per autenticazione:",
    privateKeyPasswordLabel: "Password per il file della chiave privata:",
    privateKeyPasswordPlaceholder:
      "Inserisci la password del file della chiave privata",
    helperTextFirmware:
      "Invia il pacchetto firmware per la verifica e chiedi l'approvazione dell'Operatore.",
    helperTextBackup:
      "Invia il pacchetto backup per la verifica e chiedi l'approvazione dell'Operatore.",
    cancelButtonText: "Annulla",
    askForApprovalButtonText: "Richiedi approvazione",
    pleaseFixFields: "Si prega di correggere i seguenti campi:",
    failedToCreateInstallationProcess:
      "Impossibile creare il processo di installazione",
    installationProcessAlreadyExists:
      "Per questa macchina e già attivo un processo di installazione.",
    targetPathLabelWithoutColon: "Percorso di destinazione sulla macchina",
    usernameLabelWithoutColon: "Nome utente",
    privateKeyFileForAuthLabelWithoutColon:
      "File chiave privata per autenticazione",
    passwordOrPrivateKeyRequired:
      "Inserisci la password o carica il file di chiave privata",
  },
};

export const otaPushFirmwareModalEs = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Cerrar modal de envio de firmware",
    closePushBackupModalAriaLabel: "Cerrar modal de envio de respaldo",
    titleFirmware: "Enviar firmware",
    titleBackup: "Enviar respaldo",
    firmwareSectionTitle: "El firmware",
    backupSectionTitle: "El respaldo",
    uploadedAtLabel: "subido el",
    machineSectionTitle: "se enviara a la maquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "El paquete de firmware contiene las siguientes carpetas:",
    backupFoldersSectionTitle:
      "El paquete de respaldo contiene las siguientes carpetas:",
    targetPathLabel: "Ruta de destino en la maquina:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Nombre de usuario:",
    usernamePlaceholder: "Introduce el nombre de usuario",
    passwordLabel: "Contraseña:",
    passwordPlaceholder: "Introduce la contraseña",
    showPasswordTooltip: "Mostrar contraseña",
    hidePasswordTooltip: "Ocultar contraseña",
    privateKeyFileForAuthLabel: "Archivo de clave privada para autenticacion:",
    privateKeyPasswordLabel: "Contraseña para el archivo de clave privada:",
    privateKeyPasswordPlaceholder:
      "Introduce la contraseña del archivo de clave privada",
    helperTextFirmware:
      "Envia el paquete de firmware para verificacion y solicita la aprobacion del Operador.",
    helperTextBackup:
      "Envia el paquete de respaldo para verificacion y solicita la aprobacion del Operador.",
    cancelButtonText: "Cancelar",
    askForApprovalButtonText: "Solicitar aprobacion",
    pleaseFixFields: "Por favor, corrija los siguientes campos:",
    failedToCreateInstallationProcess:
      "No se pudo crear el proceso de instalacion",
    installationProcessAlreadyExists:
      "Ya hay un proceso de instalacion activo para esta maquina.",
    targetPathLabelWithoutColon: "Ruta de destino en la maquina",
    usernameLabelWithoutColon: "Nombre de usuario",
    privateKeyFileForAuthLabelWithoutColon:
      "Archivo de clave privada para autenticacion",
    passwordOrPrivateKeyRequired:
      "Debe proporcionar contraseña o archivo de clave privada",
  },
};

export const otaPushFirmwareModalNl = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Firmware-pushvenster sluiten",
    closePushBackupModalAriaLabel: "Back-up-pushvenster sluiten",
    titleFirmware: "Firmware pushen",
    titleBackup: "Back-up pushen",
    firmwareSectionTitle: "De firmware",
    backupSectionTitle: "De back-up",
    uploadedAtLabel: "geupload op",
    machineSectionTitle: "wordt naar de machine gepusht",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle: "Het firmwarepakket bevat de volgende mappen:",
    backupFoldersSectionTitle: "Het back-uppakket bevat de volgende mappen:",
    targetPathLabel: "Doelpad op de machine:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Gebruikersnaam:",
    usernamePlaceholder: "Voer gebruikersnaam in",
    passwordLabel: "Wachtwoord:",
    passwordPlaceholder: "Voer wachtwoord in",
    showPasswordTooltip: "Wachtwoord tonen",
    hidePasswordTooltip: "Wachtwoord verbergen",
    privateKeyFileForAuthLabel: "Privatesleutelbestand voor authenticatie:",
    privateKeyPasswordLabel: "Wachtwoord voor het privatesleutelbestand:",
    privateKeyPasswordPlaceholder:
      "Voer wachtwoord voor privatesleutelbestand in",
    helperTextFirmware:
      "Stuur het firmwarepakket ter verificatie en vraag de Operator om goedkeuring.",
    helperTextBackup:
      "Stuur het back-uppakket ter verificatie en vraag de Operator om goedkeuring.",
    cancelButtonText: "Annuleren",
    askForApprovalButtonText: "Goedkeuring vragen",
    pleaseFixFields: "Los de volgende velden op:",
    failedToCreateInstallationProcess: "Installatieproces maken is mislukt",
    installationProcessAlreadyExists:
      "Er is al een installatieproces actief voor deze machine.",
    targetPathLabelWithoutColon: "Doelpad op de machine",
    usernameLabelWithoutColon: "Gebruikersnaam",
    privateKeyFileForAuthLabelWithoutColon:
      "Privatesleutelbestand voor authenticatie",
    passwordOrPrivateKeyRequired:
      "Voer wachtwoord in of upload een privatesleutelbestand",
  },
};

export const otaPushFirmwareModalTr = {
  [pageNameKey]: {
    closePushFirmwareModalAriaLabel: "Push firmware modunu kapat",
    closePushBackupModalAriaLabel: "Push yedekleme modunu kapat",
    titleFirmware: "Firmware'i itin",
    titleBackup: "Yedeklemeyi itin",
    firmwareSectionTitle: "Ürün yazılımı",
    backupSectionTitle: "Yedekleme",
    uploadedAtLabel: "yüklendi",
    machineSectionTitle: "makineye itilecek",
    machineIdLabel: "İD",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "Ürün yazılımı paketi aşağıdaki klasörleri içerir:",
    backupFoldersSectionTitle: "Yedekleme paketi aşağıdaki klasörleri içerir:",
    targetPathLabel: "Makinedeki hedef yol:",
    targetPathPlaceholder: "/appldisk",
    usernameLabel: "Kullanıcı adı:",
    usernamePlaceholder: "Kullanıcı adını girin",
    passwordLabel: "Şifre:",
    passwordPlaceholder: "Şifreyi girin",
    showPasswordTooltip: "Şifreyi göster",
    hidePasswordTooltip: "Şifreyi gizle",
    privateKeyFileForAuthLabel: "Kimlik doğrulama için özel anahtar dosyası:",
    privateKeyPasswordLabel: "Özel Anahtar dosyasının şifresi:",
    privateKeyPasswordPlaceholder: "Özel anahtar dosyası şifresini girin",
    helperTextFirmware:
      "Donanım yazılımı paketini doğrulama için gönderin ve Operatörden onay isteyin.",
    helperTextBackup:
      "Yedekleme paketini doğrulama için gönderin ve Operatörden onay isteyin.",
    cancelButtonText: "İptal etmek",
    askForApprovalButtonText: "Onay İste",
    pleaseFixFields: "Lütfen aşağıdaki alanları düzeltin:",
    failedToCreateInstallationProcess: "Yükleme işlemi oluşturulamadı",
    installationProcessAlreadyExists:
      "Bu makine için bir yükleme işlemi zaten etkin.",
    targetPathLabelWithoutColon: "Makinedeki hedef yol",
    usernameLabelWithoutColon: "Kullanıcı adı",
    privateKeyFileForAuthLabelWithoutColon:
      "Kimlik doğrulama için özel anahtar dosyası",
    passwordOrPrivateKeyRequired:
      "Kimlik doğrulama için Şifre veya Özel anahtar dosyası",
  },
};
